import { breakpoints } from '@fiverr-private/sass/helpers';

export const IMAGE_RESOLUTIONS = [
    {
        media: `(min-width: ${breakpoints.lg}px)`,
        config: { width: 1600 },
    },
    {
        media: `(min-width: ${breakpoints.sm}px)`,
        config: { width: 1200 },
    },
    {
        media: `(min-width: ${breakpoints.xs}px)`,
        config: { width: 600 },
    },
];

export const footerImageUrl = 'acc5a25311d5badb8be8b46d0f41c56b-1589977500315/ideas-footer-image.png';
